import {Component} from "react";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import AvvisiIcon from "../../../media/images/AvvisiIcon.mjs";
import TextLabel from "../../../Controls/TextLabel.mjs";
import Glob from "../../../libs/Glob.mjs";

const prefix="AvvisiPreviewRecipients";

const AvvisiPreviewRecipients = class extends Component {
	constructor(props) {
		super(props);
		this.state = {}
		this.load = this.load.bind(this);
		this.close = this.close.bind(this);
	}
	componentDidMount() {
		this.load();
	}
	async load() {
		this.setState({ list: (await Glob.api({entity:"admin",operation:"anagrafica-entries"},{ list: this.props.list }))?.list });
	}
	close() {
		this.setState({list: false });
		if ( typeof this.props.onClose === 'function') this.props.onClose();
	}
	render() {
		if ( ! this.state.list ) return null;
		return (
			<Modal
				fade={false}
				keyboard={false}
				className={prefix}
				id={this.uid}
				size='l'
				isOpen={true}
				toggle={this.close}
			>
				<ModalHeader toggle={this.close}>
					<AvvisiIcon/>
					<TextLabel value={"Recipients"}/>
				</ModalHeader>
				<ModalBody>
					<ol>
						{ this.state.list.map((c,i)=>(
							<li key={i}>
								{ typeof c === 'string' ? <b>{c}</b> : [c.nome,c.ruolo,c.area,c.cliente].filter(x=>!!x).join(', ') }
							</li>
						))}
					</ol>
				</ModalBody>
			</Modal>
		)
	}
}

export default AvvisiPreviewRecipients;